import {LocalStorageManager} from 'common/contexts/local-storage-manager/types';
import {USER_DEPENDENT_LOCAL_STORAGE_KEYS} from 'common/report/constants';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';
import {UserPersistence} from 'common/report/persistence';

/**
 *  Clears all persisted data that could be tied to a user.
 *  Includes:
 *  - fetchCache: Could be a security risk to allow user A to see user B's data
 *  - localStorage: Subset of localStorage keys that are user dependent
 */
export function purgeStorage(localStorage: LocalStorageManager) {
  purgeFetchCache({everything: true});

  // Old way of purging localStorage - TODO(jakub): remove this line
  // After UserPersistence usage is eliminated
  UserPersistence.purge();

  // New way of purging localStorage with panel context
  for (const key of USER_DEPENDENT_LOCAL_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}
